import * as actionTypes from '../constants/recentlyViewedConstants';

export const recentlyViewedReducer = (state = { products: [] }, action) => {
    switch (action.type) {
      case actionTypes.ADD_PRODUCT_TO_RECENTLY_VIEWED_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case actionTypes.ADD_PRODUCT_TO_RECENTLY_VIEWED_SUCCESS:
        return {
          ...state,
          loading: false,
          products: [action.payload.product, ...(state.products || [])],
        };
      case actionTypes.ADD_PRODUCT_TO_RECENTLY_VIEWED_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      case actionTypes.GET_RECENTLY_VIEWED_PRODUCTS_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case actionTypes.GET_RECENTLY_VIEWED_PRODUCTS_SUCCESS:
        return {
          ...state,
          loading: false,
          products: action.payload,
        };
      case actionTypes.GET_RECENTLY_VIEWED_PRODUCTS_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };